import { z } from "zod"
import { SalesSkuSchema } from "./SalesCommons"
import { SalesProductBundleDetailsSchema } from "./SalesProductModel"

export const SalesCartProductModelSchema = z.object({
	/**
	 * ID of the bundle, variant or parent product
	 */
	id: z.string().min(1),

	/**
	 * Only if the item is a parent product's variant will this be populated.
	 *
	 * If the item is a parent product or a bundle, this will be null.
	 * (We do not support bundle variants)
	 */
	parent_id: z.string().min(1).nullable(),

	/**
	 * Name of the bundle, variant or parent product.
	 */
	name: z.string().min(1),

	/**
	 * If the item is a product variant, this field contains the parent's name.
	 *
	 * (We do not support bundle variants)
	 */
	parent_name: z.string().min(1).nullable(),

	/**
	 * Quantity of the bundle, variant or parent product
	 */
	quantity: z.number().min(1),

	/**
	 * Price of the bundle, variant or parent product.
	 * If the item was on sale at the time of adding, this will be the sale price.
	 */
	price: z.number().min(0),

	/**
	 * Total discount code discount applied to the item.
	 *
	 * If this item is a bundle item, this field DOES NOT
	 * include the discount offered by a bundle against its items.
	 * Access the bundle_details property for this information.
	 */
	discount_total: z.number().min(0),

	/**
	 * Images of the bundle, variant or parent product
	 */
	images: z.array(z.string().min(1)).min(1),

	/**
	 * Sku of the bundle, variant or parent product
	 */
	sku: SalesSkuSchema.nullable(),

	/**
	 * ONLY if the item is a bundle, this will be populated.
	 */
	bundle_details: SalesProductBundleDetailsSchema.nullable(),
})
export type SalesCartProductModel = z.infer<typeof SalesCartProductModelSchema>
